var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-row',{attrs:{"vs-align":"center","vs-type":"flex","vs-justify":"space-around","vs-w":"12"}},[_c('vs-col',{attrs:{"vs-type":"flex","vs-justify":"center","vs-align":"center","vs-w":"12"}},[_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }